import React from 'react';
import { isRecruiterSide } from 'src/config/env.config';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	score: number;
}

const TechnicalRoundOverallRoundScore = ({ score }: Props) => {
	const { user } = useUserContext();
	return (
		<div className="sm:pb-5 sm:border-b-[1px] sm:border-solid sm:border-[#00CFDE]">
			<div className="text-sm dark:text-[#E5FFFF] text-[#28293D]">Meeting score</div>
			<div className="mt-2 text-xl dark:text-white text-[#28293D]">
				<span className="text-[32px] font-bold">{Math.round(score)}</span>
				{isRecruiterSide || !user ? '' : ' / 1000'}
			</div>
		</div>
	);
};

export default TechnicalRoundOverallRoundScore;
